import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class FirGridSaveService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  htieNewElectionSave(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }

    const activeFilters = _.merge({}, filterParams);
    const pivot = data?.rowData?.PIVOT_COLUMN_UNPIVOTED_DATA?.[data.col_id] || {};
    const jsonObj = [{
      FIR_HO_LEID: activeFilters.fir_ho_leid,
      HTIE_PASSIVE: 'N',
      NEW_ELECTION: data.rowData[data.col_id],
      JOB_ID: data.rowData.JOB_ID,
      FTC_ID: pivot.FTC_ID ?? null,
      PASSIVE_ID: pivot.PASSIVE_ID ?? null,
      SUBF_ID: pivot.SUBF_ID ?? null,
      FPHCI_ID: pivot.FPHCI_ID ?? null
    }];

    const params = _.extend(
      { jsonObj: JSON.stringify(jsonObj) },
      _.merge({}, globalService?.globalParams || globalService || {}, activeFilters)
    );

    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=q78v9b`,
      params,
      globalService,
      activeFilters
    );
  }

  htiePassiveNewElectionSave(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }

    const activeFilters = _.merge({}, filterParams);
    const jsonObj = [{
      FIR_HO_LEID: activeFilters.fir_ho_leid,
      HTIE_PASSIVE: 'Y',
      NEW_ELECTION: data.rowData.PASSIVE_FPCHI,
      JOB_ID: data.rowData.JOB_ID,
      FTC_ID: null,
      PASSIVE_ID: null,
      SUBF_ID: null,
      FPHCI_ID: null
    }];

    const params = _.extend(
      { jsonObj: JSON.stringify(jsonObj) },
      _.merge({}, globalService?.globalParams || globalService || {}, activeFilters)
    );

    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=q78v9b`,
      params,
      globalService,
      activeFilters
    );
  }

  tbImportFromFDMAlert(data: any): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }
    if (data.rowData[data.col_id] === 1 && data.rowData.TB_STATUS === 'Loaded') {
      return of({
        callSuccess: '0',
        warningMessage:
          `TB is already loaded for LEID - ${data.rowData.LEID} Tax Code - ${data.rowData.CDR_NO} ME Code - ${data.rowData.ME_CODE} Rpt Pd - ${data.rowData.REPORTING_PERIOD}. Please uncheck Import checkbox if you don't wish to override the existing TB.`
      });
    }
    return of({ callSuccess: '1' });
  }
}
